import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-monthly-totals-dialog',
  templateUrl: './monthly-totals-dialog.component.html',
  styleUrls: ['./monthly-totals-dialog.component.scss'],
  standalone: false
})
export class MonthlyTotalsDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      borrowerId: number;
      readOnly?: boolean;
    }
  ) { }

  ngOnInit(): void {
  }

}
